import { useTranslation } from "react-i18next"
import { HiOutlineUserAdd } from "react-icons/hi"
import { LuWrench } from "react-icons/lu"
import { FaUserTie } from "react-icons/fa"
import { TabsWrapper } from "./styles"
import { Dispatch, SetStateAction } from "react"
interface IProps {
	setActiveTab: Dispatch<SetStateAction<1 | 2 | 3>>
	activeTab: 1 | 2 | 3
}
export default function Tabs({ setActiveTab, activeTab }: IProps) {
	const { t } = useTranslation()
	const ListOptions = [
		{
			id: 1,
			icon: <HiOutlineUserAdd />,
			label: t("UserManagement.team_member"),
		},
		{
			id: 2,
			icon: <LuWrench />,
			label: t("UserManagement.add_a_service_provider"),
		},
		{
			id: 3,
			icon: <FaUserTie />,
			label: t("UserManagement.add_owner"),
		},
	]
	return (
		<TabsWrapper>
			{ListOptions.map((item) => {
				return (
					<button
						type='button'
						key={item.id}
						className={item.id === activeTab ? "active" : ""}
						onClick={() => setActiveTab(item.id as 1 | 2 | 3)}
					>
						<span>{item.icon}</span>
						<span>{item.label}</span>
					</button>
				)
			})}
		</TabsWrapper>
	)
}
